import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { userSelector } from "store/auth";
import { noteSelector } from "store/note";
import { getNodeHeight, getWindowScrollingValue } from "utils/helpers";

const Header = ({ children, type = "", className = "", isSticky, isFixed, isDemo }) => {
	// redux global state
	const note = useSelector(noteSelector);
	const user = useSelector(userSelector);

	// ref hook
	const rootHeaderRef = useRef(null);

	// effect hook
	useEffect(() => {
		let lastScrollTop = rootHeaderRef?.current?.offsetTop;
		let lastWindowWidth = window.innerWidth;
		let headerHeight;
		let headerChangePoint;
		const scrollingClassName = "root-header-scrolling";
		const scrollingUpClassName = "root-header-scrolling-up";
		const scrollingDownClassName = "root-header-scrolling-down";
		const calculateHeights = () => {
			headerHeight = getNodeHeight(rootHeaderRef?.current);
			headerChangePoint = headerHeight || 0;
		};

		const headerScrollHandler = () => {
			let windowScroll = getWindowScrollingValue();

			if (windowScroll > headerChangePoint) {
				rootHeaderRef?.current?.classList.add(scrollingClassName);
				if (
					windowScroll < lastScrollTop ||
					window.innerHeight + window.pageYOffset >= document.body.offsetHeight
				) {
					rootHeaderRef?.current?.classList.remove(scrollingDownClassName);
					rootHeaderRef?.current?.classList.add(scrollingUpClassName);
				} else {
					rootHeaderRef?.current?.classList.remove(scrollingUpClassName);
					rootHeaderRef?.current?.classList.add(scrollingDownClassName);
				}
			} else {
				rootHeaderRef?.current?.classList.remove(
					scrollingClassName,
					scrollingUpClassName,
					scrollingDownClassName
				);
			}
			lastScrollTop = windowScroll;
		};

		if (isSticky || isFixed) {
			calculateHeights();
			headerScrollHandler();

			window.addEventListener("scroll", headerScrollHandler);
			window.addEventListener("resize", () => {
				if (window.width !== lastWindowWidth) {
					calculateHeights();
					lastWindowWidth = window.innerWidth;
				}
				headerScrollHandler();
			});
			window.addEventListener("orientationchange", () => {
				if (window.width !== lastWindowWidth) {
					calculateHeights();
					lastWindowWidth = window.innerWidth;
				}
				headerScrollHandler();
			});
		}

		return () => {
			if (isSticky || isFixed) {
				window.removeEventListener("scroll", headerScrollHandler);
				window.removeEventListener("resize", () => {
					calculateHeights();
					headerScrollHandler();
				});
				window.removeEventListener("orientationchange", () => {
					calculateHeights();
					headerScrollHandler();
				});
			}
		};
	}, [rootHeaderRef, note?.id, user, isSticky, isFixed]);

	return (
		<header
			className={`${isSticky ? "sticky-top" : ""} ${isFixed ? "fixed-top" : ""} ${
				isDemo ? "is-demo" : ""
			} d-print-none root-header ${type ? `root-header-${type}` : ""} ${className}`}
			ref={rootHeaderRef}>
			{children}
		</header>
	);
};

export default Header;
